export default "__VITE_ASSET__dd305125__"